export default "__VITE_ASSET__Cr2gl9iP__"